import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// import Grid from '@mui/material/Grid';
// import LogisticsIcon from '@mui/icons-material/LocalShippingOutlined';

import { LogisticsTableContainer } from '../../components/logistics';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchLogistics } from '../../actions/adminActions';

import './admin.scss';

const LogisticsPage = ({ fetchLogistics, logistics, countries, users }) => {
  useEffect(() => {
    fetchLogistics();
  }, [fetchLogistics])

  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Logistics' number={logistics?.length} icon={<LogisticsIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Logistics' number={logistics?.length} icon={<LogisticsIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Logistics' number={logistics?.length} icon={<LogisticsIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <LogisticsTableContainer
        logistics={logistics}
        countries={countries}
        users={users}
        withButton
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  logistics: state.logistics.list,
  countries: state.countries.list,
  users: state.users.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchLogistics: () => dispatch(fetchLogistics()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LogisticsPage);
